export const fonts = {
    custom: {
        families: ['PF Agora Slab Pro:n4,i4,n7,i7', 'Verdana:n4,i4,n7,i7'],
        urls: ['./css/fonts.css']
    }
    /* ,
     google: {
         families: ['Roboto:400,700:cyrillic']
     },*/
    /*
     typekit: {
         id: 'xxxxxx'
     }*/
};
